// The list panel's chrome (filter selects, segmented counters, keyboard hints)
// and the right-hand drawer the branch transfer uses. Presentation only.
import React, { useEffect } from "react";
import { AxCaret, AxClearIcon } from "./adminUi";

// One of the selects under the search box. It highlights itself while a value
// is chosen, so it is obvious the list is filtered.
export const AxFilterSelect = ({ value, onChange, placeholder, options = [], ariaLabel }) => (
  <div className={"axa-fsel" + (value ? " on" : "")}>
    <select value={value} onChange={onChange} aria-label={ariaLabel || placeholder}>
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value ?? o} value={o.value ?? o}>
          {o.label ?? o}
        </option>
      ))}
    </select>
    <AxCaret />
  </div>
);

// All / Active / Inactive pills with counts.
export const AxSegments = ({ value, onChange, items = [] }) => (
  <>
    {items.map((s) => (
      <button
        key={s.key}
        type="button"
        className="axa-seg"
        aria-pressed={value === s.key}
        onClick={() => onChange(s.key)}
      >
        {s.label} <span className="n">{s.count}</span>
      </button>
    ))}
  </>
);

// The strip of keyboard hints along the bottom.
export const AxStatusKeys = ({ keys = [], right }) => (
  <>
    {keys.map((k) => (
      <span className="grp" key={k.k}>
        <span className="axa-kbd">{k.k}</span>
        <span>{k.t}</span>
      </span>
    ))}
    <span className="sp" />
    {right ? <span className="grp">{right}</span> : null}
  </>
);

// Right-docked drawer. Rendered at the end of the page, outside the grid.
export const AxDrawer = ({ open, onClose, icon, title, subtitle, children, footer }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        className={"axa-scrim" + (open ? " show" : "")}
        hidden={!open}
        onClick={onClose}
      />
      <aside className={"axa-drawer" + (open ? " show" : "")} aria-hidden={!open}>
        <div className="axa-drhead">
          {icon ? <span className="ic">{icon}</span> : null}
          <div>
            <div className="t">{title}</div>
            {subtitle ? <div className="s">{subtitle}</div> : null}
          </div>
          <button type="button" className="axa-dclose" aria-label="Close" onClick={onClose}>
            <AxClearIcon />
          </button>
        </div>
        <div className="axa-drbody">{open ? children : null}</div>
        {footer ? <div className="axa-drfoot">{footer}</div> : null}
      </aside>
    </>
  );
};
